import * as yup from "yup";

export const EditProcedureValidation = yup.object().shape({
	ProjectGroup: yup.number().min(0, "Please choose a group.").required(),
	Name: yup.string().min(1, "Please enter a name").required(),
	Responsible: yup
		.number()
		.min(1, "Please choose a person responsible for this procedure.")
		.required(),
});
